import { render, staticRenderFns } from "./EnableAutoCache.vue?vue&type=template&id=bb05da42"
import script from "./EnableAutoCache.vue?vue&type=script&lang=js"
export * from "./EnableAutoCache.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports